"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ICONS = {
  international: 'international',
  voice: 'call',
  data: 'data',
  sms: 'sms',
  student: 'student',
  combo: 'bundles',
  'under 24': 'add-ons',
  'cu pass': 'add-ons',
  cupass: 'add-ons',
  offers: 'offer-badge-percent',
  flexbasic: 'trophy',
  unlimited: 'unlimited'
};
var _default = ICONS;
exports.default = _default;